import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const DealCommitmentsModelSchema = z
  .object({
    id: z.string(),
    deal_id: z.string().nullish(),
    fund_id: z.string().nullish(),
    amount: z.number().nullish()
  })
  .strict()

export const DealCommitmentsModelFields = makeFieldKeys(DealCommitmentsModelSchema)

export type DealCommitmentsModel = z.infer<typeof DealCommitmentsModelSchema>

function validateDealCommitmentsModel(data: unknown): DealCommitmentsModel {
  try {
    return validateWithZodSchema(DealCommitmentsModelSchema, data, 'deal commitments model')
  } catch (error) {
    throw new Error(`Deal commitments model validation failed: ${error}`)
  }
}
